import styled from 'styled-components';

export const AllClassToggle = styled.a`
  font-size: 13px;
`;

export const Wrapper = styled.div`
  margin: 24px 0;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  > * {
    margin-left: 16px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const VisibilityToggleWrapper = styled.div`
  i.icon {
    margin-top: 5px;
  }
`;
